import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import GS from '../../grafsync/grafsync';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles, gstheme } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { MAX_PASSWORD_LENGTH } from '../utils/constants';
import { validatePassword } from '../utils/utils';
import { Typography } from '@material-ui/core';

const fields = {
    currentPassword: "Current Password",
    newPassword: "New Password",
    repeatNewPassword: "Repeat New Password"
};

class MyPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            checking: false,
            changeAccepted: null,
            currentPassword: "",
            newPassword: "",
            repeatNewPassword: "",
            currentPasswordValidity: true,
            newPasswordValidity: true,
            repeatNewPasswordValidity: true,
            isDirty: false,
            isValid: false
        };
    }

    handleChange = (event) => {
        const t = event.target;
        const validityField = t.name + "Validity";
        this.setState({ [t.name]: t.value, isDirty: true, changeAccepted: null, [validityField]: validatePassword(t.value) });
    };

    saveUpdates = async () => {
        const { currentPassword, newPassword } = this.state;
        this.setState({ isDirty: false, checking: true });
        const ok = await GS.changePassword(this.props.user.id, {
            currentPassword,
            newPassword
        });
        this.setState({ checking: false, changeAccepted: ok });
    }

    render() {

        const { classes } = this.props;
        const { isDirty, currentPassword, newPassword, repeatNewPassword, checking, changeAccepted } = this.state;
        const isValid = isDirty && newPassword.length >= 8 && newPassword === repeatNewPassword && currentPassword !== newPassword;

        return (
            <form autoComplete="off">
                <Grid container spacing={2} classes={
                    {
                        "spacing-xs-2": this.props.classes.fullGrid
                    }
                }>
                    <Grid item xs={12}>
                        {Object.keys(fields).map((key, index) =>
                            <TitledTextField
                                dataTest={key}
                                key={index}
                                className={classes.loginText}
                                margin={index > 0}
                                isReadOnly={checking}
                                name={key}
                                required={true}
                                title={fields[key]}
                                type="password"
                                error={this.state[key + "Validity"] === false}
                                errorText={this.state[key + "Validity"] === false ? "Password invalid." : ""}
                                text={this.state[key]}
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                maxLength={MAX_PASSWORD_LENGTH}
                                helperText={key === "newPassword" ?
                                    repeatNewPassword === currentPassword && repeatNewPassword.length > 0 ?
                                        "New password is the same as current password."
                                        :
                                        "Minimum 8 characters including lower case, upper case, a number and a special character from !@#$%^&*"
                                    :
                                    key === "repeatNewPassword" && newPassword !== repeatNewPassword ?
                                        "Passwords do not match."
                                        :
                                        ""
                                }
                            />
                        )}
                    </Grid>
                    <Grid item xs={6}>
                        {changeAccepted === false && <Typography variant="body2">
                            <ErrorIcon style={{ color: gstheme.palette.error.main, verticalAlign: 'middle', marginRight: 10 }} fontSize="large" />
                            <span>Current password incorrect.</span>
                        </Typography>}
                        {changeAccepted === true && <Typography variant="body2">
                            <CheckCircleIcon fontSize="large" style={{ color: gstheme.palette.secondary.main, verticalAlign: 'middle', marginRight: 10 }} />
                            <span>Password change accepted.</span>
                        </Typography>}
                    </Grid>
                    <Grid item xs={6}>
                        <div style={{ float: 'right' }}>
                            <PrimaryButton dataTest="change" disabled={!isValid || checking} onClick={this.saveUpdates}>Change</PrimaryButton>
                        </div>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

MyPassword.propTypes = {
    classes: PropTypes.object,
    user: PropTypes.object.isRequired
};

export default withStyles(styles)(MyPassword);